import { methodList } from './../methodManage/request';
import { intermediaryList } from './../../insurance/agencyManage/request';
import { paymentList, paymentDownload } from './request';
import infoModel from './infoModel.vue';
import { downloadFileFun } from '@/utils/public';
export default {
  components: {
    infoModel
  },
  data() {
    return {
      infoShow: false,
      form: {},
      typeList: [],
      intermediaryList: [],
      data: [],
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      columns: [{
        slots: {
          title: '序号'
        },
        dataIndex: 'index',
        key: '1',
        align: 'center',
        width: 100,
        scopedSlots: {
          customRender: 'index'
        }
      }, {
        slots: {
          title: '交易流水号'
        },
        dataIndex: 'tradeNo',
        key: '2',
        align: 'center'
      }, {
        slots: {
          title: '订单号'
        },
        dataIndex: 'orderNo',
        key: '3',
        align: 'center'
      }, {
        slots: {
          title: '支付方式'
        },
        dataIndex: 'payTypeName',
        key: '4',
        align: 'center',
        scopedSlots: {
          customRender: 'payTypeName'
        }
      }, {
        slots: {
          title: '支付金额'
        },
        dataIndex: 'totalFee',
        key: '5',
        align: 'center'
      }, {
        slots: {
          title: '支付来源'
        },
        dataIndex: 'appName',
        key: '6',
        align: 'center'
      }, {
        slots: {
          title: '交易状态'
        },
        dataIndex: 'payStatusName',
        key: '7',
        align: 'center',
        scopedSlots: {
          customRender: 'payStatusName'
        }
      }, {
        slots: {
          title: '操作'
        },
        key: '8',
        align: 'center',
        scopedSlots: {
          customRender: 'action'
        },
        width: 100
      }]
    };
  },
  created() {
    methodList().then(res => {
      this.typeList = res.items;
    });
    intermediaryList({
      type: 1
    }).then(res => {
      this.intermediaryList = res;
    });
    this.getDataFun();
  },
  methods: {
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    getDataFun() {
      let obj = this.form;
      obj.pageSize = this.pagination.pageSize;
      obj.page = this.pagination.current;
      paymentList(obj).then(res => {
        this.data = res.items;
        this.pagination.total = res.totalNum;
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    handleSee(val) {
      this.infoShow = true;
      this.$nextTick(() => {
        this.$refs.infoFrom.init(val.orderId);
      });
    },
    downloadFun() {
      let obj = this.form;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      paymentDownload(obj).then(res => {
        console.log(res);
        let nowDate = new Date();
        let time = nowDate.getFullYear() + '-' + Number(Number(nowDate.getMonth()) + 1) + '-' + nowDate.getDate();
        downloadFileFun(res, 'application/vnd.ms-excel', this.$t('支付列表') + time + '.xlsx');
      });
    }
  }
};